const components = [
    ['uploader', 'img', 'video', 'pdf-doc', 'file'],
    ['transfer', '']
];

/**
 * 加载自定义组件函数
 * @param {Vue} vue 需要传入Vue作为参数，自身没有导入Vue
 */
export function loadCustomComponents(vue) {
    for (let key of components) {
        if (key instanceof Array) {
            const pre = key.shift();

            vue.component(`${pre}-core`, () => import(`./${pre}/core.vue`))
            for (let ui of key) {
                vue.component(`${pre}-ui${ui && ('-' + ui)}`, () => import(`./${pre}/ui${ui && ('-' + ui)}`))
            }
        }
        else {
            vue.component(`c-${key}`, () => import(`./${key}.vue`));
        }
    }
    vue.component('transfer-sider', () => import(`./transfer-sider.vue`));
}
